<template>
  <div class="user-list page page-with-table p-2">
    <page-header class="mb-2" :title="$t('Users')">
      <template v-slot:buttons>
        <add-new-button @click="onNewUserClick">
          <font-awesome-icon icon="plus-circle" class="icon"/>
          {{ $t('New User') }}
        </add-new-button>
      </template>
    </page-header>
    <div class="card content-wrapper p-2">
      <UserTable/>
    </div>
    <user-modal/>
  </div>
</template>

<script>
  import AddNewButton from "../../../core/components/common/AddNewButton";
  import {createNamespacedHelpers} from "vuex";
  import UserModal from "./UserModal";
  import UserTable from "./UserTable";
  import PageHeader from "../../../core/components/page-header/PageHeader";

  const {mapActions, mapState} = createNamespacedHelpers('setup/user');
  const {mapState: mapStateGlobal} = createNamespacedHelpers('global');

  export default {
    name: "User",
    components: {PageHeader, UserTable, UserModal, AddNewButton},
    computed: {
      ...mapState({
        tableData: state => state.tableData
      }),
    },
    methods: {
      ...mapActions(['showModal']),
      onNewUserClick() {
        this.showModal();
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "./scss/variables";

  .user-list {
    @include list-view-wrapper;
  }
</style>

